(function () {
  'use strict';

  var section = document.querySelector('.bundle-tabs');
  if (!section) return;

  var ACTIVE_TAB = 'bundle-tabs__tab--active';
  var ACTIVE_PANEL = 'bundle-tabs__panel--active';

  var tabs = section.querySelectorAll('[data-tab]');
  var panels = section.querySelectorAll('[data-panel]');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var index = tab.dataset.tab;

      tabs.forEach(function (t) {
        t.classList.remove(ACTIVE_TAB);
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function (p) {
        p.classList.remove(ACTIVE_PANEL);
      });

      tab.classList.add(ACTIVE_TAB);
      tab.setAttribute('aria-selected', 'true');

      var panel = section.querySelector('[data-panel="' + index + '"]');
      if (panel) panel.classList.add(ACTIVE_PANEL);

      tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
  });

  section.querySelectorAll('.bundle-tabs__variant-select').forEach(function (select) {
    select.addEventListener('change', function () {
      updatePanelPrice(select);
      updatePanelSessionTimes(select);
    });
  });

  function formatMoney(cents) {
    var amount = cents / 100;
    return amount % 1 === 0
      ? amount.toLocaleString('de-DE') + ' \u20AC'
      : amount.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' \u20AC';
  }

  function updatePanelPrice(select) {
    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var price = parseInt(opt.getAttribute('data-variantprice'), 10) || 0;
    var compare = parseInt(opt.getAttribute('data-variantcompareprice'), 10) || 0;
    var hasDiscount = compare > price;

    var panel = select.closest('.bundle-tabs__panel');
    if (!panel) return;
    var priceRow = panel.querySelector('.bundle-tabs__card-price');
    if (!priceRow) return;

    var originalEl = priceRow.querySelector('.bundle-tabs__price-original');
    var sepEl = priceRow.querySelector('.bundle-tabs__price-separator');
    var saleEl = priceRow.querySelector('.bundle-tabs__price-sale');
    var savingsEl = priceRow.querySelector('.bundle-tabs__price-savings');

    if (saleEl) saleEl.textContent = formatMoney(price);
    if (originalEl) {
      originalEl.textContent = formatMoney(compare);
      originalEl.hidden = !hasDiscount;
    }
    if (sepEl) sepEl.hidden = !hasDiscount;
    if (savingsEl) {
      savingsEl.textContent = 'Spare ' + formatMoney(compare - price);
      savingsEl.hidden = !hasDiscount;
    }
  }

  function parseSessionString(s) {
    // Format: "Weekday, 25. April 2026 | 10:00-12:00"
    if (!s) return { date: '', time: '' };
    var parts = s.split(' | ');
    var datePart = parts[0] || '';
    var timePart = parts.length > 1 ? parts[parts.length - 1] : '';
    var dateSegments = datePart.split('. ');
    var date = dateSegments.length > 1 ? dateSegments[dateSegments.length - 1] : datePart;
    return { date: date, time: timePart };
  }

  function getSessionTimesMap(panel) {
    var script = panel.querySelector('script[type="application/json"][data-session-times-all]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function updatePanelSessionTimes(select) {
    var panel = select.closest('.bundle-tabs__panel');
    if (!panel) return;
    var map = getSessionTimesMap(panel);
    if (!map) return;

    var opt = select.options[select.selectedIndex];
    if (!opt) return;
    var variantId = opt.getAttribute('data-variantid');
    if (!variantId) return;

    var sessions = map[variantId];
    if (!Array.isArray(sessions)) return;

    var metaNodes = panel.querySelectorAll('[data-session-meta]');
    metaNodes.forEach(function (meta) {
      var idx = parseInt(meta.getAttribute('data-session-index'), 10);
      if (isNaN(idx)) return;
      var raw = sessions[idx] || '';
      var parsed = parseSessionString(raw);
      var dateEl = meta.querySelector('[data-session-date-text]');
      var timeEl = meta.querySelector('[data-session-time-text]');
      if (dateEl) dateEl.textContent = parsed.date;
      if (timeEl) timeEl.textContent = parsed.time;
    });
  }
})();
